const MONTHS = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
const PROJECT_TYPES = new Set(["pontual", "avulso", "projeto", "campanha", "temporada", "acao_especial"]);

export function localDateKey(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function cycleLabel(task) {
  const match = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(task.ciclo_competencia || "");
  if (PROJECT_TYPES.has(task.ciclo_tipo)) return task.ciclo_titulo || "Projeto pontual";
  if (match) return `${MONTHS[Number(match[2]) - 1]} ${match[1]}`;
  return task.ciclo_titulo || (task.ciclo_id ? "Ciclo não identificado" : "Sem ciclo");
}

export function cycleFilterKey(task) {
  if (!task.ciclo_id) return "sem-ciclo";
  if (PROJECT_TYPES.has(task.ciclo_tipo)) return `projeto:${task.ciclo_id}`;
  return task.ciclo_competencia || `ciclo:${task.ciclo_id}`;
}

export function dailyTaskBuckets(data, today = data.hoje || localDateKey()) {
  const tasks = new Map();
  [...(data.atrasadas || []), ...(data.proximos_prazos || [])].forEach((task) => {
    if (task.prazo && !["concluido", "cancelado"].includes(task.status)) tasks.set(task.id, task);
  });
  const sorted = [...tasks.values()].sort((a, b) => a.prazo.localeCompare(b.prazo) || a.id.localeCompare(b.id));
  return { hoje: sorted.filter((t) => t.prazo === today), atraso: sorted.filter((t) => t.prazo < today), proximos: sorted.filter((t) => t.prazo > today) };
}

export function groupByCycle(tasks) {
  const groups = new Map();
  tasks.forEach((task) => {
    const key = task.ciclo_id || `sem-ciclo:${task.cliente_id || "interno"}`;
    if (!groups.has(key)) groups.set(key, { key, label: cycleLabel(task), client: task.cliente_empresa || "Estúdio", tasks: [] });
    groups.get(key).tasks.push(task);
  });
  return [...groups.values()];
}

// Presentation only: custom titles and the underlying task are never renamed.
export function taskDisplayTitle(task) {
  return task.titulo === "Programar posts no mLabs" ? "Agendar publicações no mLabs" : task.titulo;
}
